import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['popover', 'button', 'copyButton', 'status'];
  static values = { headers: String };

  toggle(event) {
    event.preventDefault();
    const open = this.popoverTarget.hidden;
    this.popoverTarget.hidden = !open;
    this.buttonTarget.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (this.hasStatusTarget) {
      this.statusTarget.hidden = true;
    }
  }

  async copy(event) {
    event.preventDefault();
    const text = this.headersValue;
    try {
      await navigator.clipboard.writeText(text);
      if (this.hasStatusTarget) {
        this.statusTarget.hidden = false;
        this.statusTarget.textContent = 'Copied!';
      }
    } catch {
      if (this.hasStatusTarget) {
        this.statusTarget.hidden = false;
        this.statusTarget.textContent = 'Copy failed. Select and copy manually.';
      }
    }
  }
}
